module.exports = __webpack_public_path__ + "static/LoginBackground-9931a1412bbbee736753c4a2e5426918.jpg";